<template>
    <div id="overlay">
        <div class="dialog-wrap">
            <div class='select-friend-top'>
                <div>
                    <span class="select-friend-close-btn" @click="CloseEvent">×</span>
                </div>
                <div>
                    <div class='dialog_title'>同伴者選択</div>
                    <div class="p-4">
                        <div class="scrollY">
                            <div v-for="item in companionPlayerSelectList" :key="item.id">
                                <input
                                    :id="item.id"
                                    type="checkbox"
                                    class="select-friend-checkbox"
                                    v-model="selectedCompanionPlayers"
                                    :value="item">
                                <div class="w-100 mb-1 friend-select-name-content">
                                    <label :for="item.id" class="p-1 friend-select-name">
                                        {{ item.family_name }}&nbsp;{{ item.given_name }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <p v-if="alertError == false" class="text-danger">{{count}}名まで選択可能となっています</p>
                        <div>
                            <button class='bluebackbutton dialogBtn' v-on:click="ClickEvent">登&nbsp;&nbsp;録</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { GET_COMPANION_LIST } from '../../../constants/companion';
import { GET_MY_PROFILE } from '../../../constants/mypage_profile';

export default {
    components: {
    },
    data () {
        return {
            // 選択されたmember_no
            selectedCompanionPlayers: [],
            // 友達リスト
            companionPlayerSelectList: [],
            count: null,
            alertError: true,
            select: [],
            loadingCount: 0
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.loadingCount = 0;
        },

       /** ----------------------------------------------
         * 同伴者一覧取得
         *  現在の予約に対する登録同伴者の一覧を取得する
         * @param reserveNo 予約番号
         * @param loginUserMemberNo 代表者会員番号
         * @count
         * @param selectedPlayer 既に選択されている同伴者
         * ---------------------------------------------- */
        GetCompanionList: async function (reserveNo, loginUserMemberNo, count, selectedPlayer) {
            var me = this;
            this.selectedCompanionPlayers = [];
            this.loadingOn();
            this.$apollo.query({
                    query: GET_COMPANION_LIST,
                    fetchPolicy: 'no-cache',
                    variables: {
                        reserve_no: reserveNo,
                        cell_id: null
                    }
            })
            .then(res => {
                var companionLists = res.data.GetCompanionList.CompanionLists;
                me.companionPlayerSelectList = [];

                 if (companionLists.length != 0) {
                    // // 表示用の連想配列を作成する
                    for (var i = 0; i < companionLists.length; i++) {
                        companionLists[i].id = companionLists[i].class_no.toString() + 
                                '-' + 
                                companionLists[i].player_no.toString();
                        const family_name = companionLists[i].family_name;
                        const given_name = companionLists[i].given_name;
                        const full_name = family_name + given_name;
                        const email = companionLists[i].email;
                        const mobile_number = companionLists[i].mobile_number;
                        const selectedIndex = selectedPlayer.findIndex(selected => {
                            const selectedFullName = selected['family_name'] + selected['given_name'];
                            const selectedEmail = selected['email'];
                            if (selectedEmail) {
                                return email === selectedEmail;
                            }
                            return selectedFullName === full_name;
                        });
                        if (selectedIndex === -1) {
                            me.companionPlayerSelectList.push(companionLists[i]);
                        }
                    }
                 } else {
                    me.GetMyProfile(loginUserMemberNo);
                 }
                this.count = count;
                me.loadingOff();
            })
            .catch(error => {
                me.error = error;
                me.loadingOff();
            });
        },

        /** ----------------------------------------------
         * ログインユーザ情報取得
         * ---------------------------------------------- */
        GetMyProfile: function (loginUserMemberNo) {
            var me = this;
            me.loadingOn();
            try {
                this.$apollo.mutate({
                        mutation: GET_MY_PROFILE,
                        variables: {
                            member_no: loginUserMemberNo,
                        }
                    }).then(res => {
                        var representative = res.data.getMyProfile.Profile[0];
                        me.companionPlayerSelectList.push({id: '1-1',
                                                           member_no: loginUserMemberNo,
                                                           family_name: representative.family_name,
                                                           given_name: representative.given_name,
                                                           email:representative.email,
                                                           mobile_number:representative.mobile_number});

                        me.loadingOff();
                    });
            } catch (error) {
                me.error = error;
                this.$store.commit("loading/setIsLoading", false);
            }
        },

        /** ----------------------------------------------
         * 登録ボタン押下
         * ---------------------------------------------- */
        ClickEvent (){
            // 入力欄が空欄の人数より選択された人数の方が多い場合
            if (this.count < this.selectedCompanionPlayers.length) {
                this.alertError = false;
            }
            // 選択された人数が適正の場合
            else if ( this.count >= this.selectedCompanionPlayers.length && this.selectedCompanionPlayers.length >= 1) {
                this.alertError = true;
                for (var i = 0; i < this.selectedCompanionPlayers.length; i++) {
                    if (this.selectedCompanionPlayers[i].member_no) {
                        this.selectedCompanionPlayers[i].selectFlag = true;
                    } else {
                        this.selectedCompanionPlayers[i].selectFlag = false;
                    }
               }
                this.$emit('fromSelectCompanion-Dialog', this.selectedCompanionPlayers);
                this.selectedCompanionPlayers = [];
            // 誰も選択されなかったら
            } else if ( this.selectedCompanionPlayers.length < 1) {
                this.alertError = true;
                this.selectedCompanionPlayers = null;
                this.$emit('fromSelectCompanion-Dialog', this.selectedCompanionPlayers);
                this.selectedCompanionPlayers = [];
            }
        },
         /** ----------------------------------------------
         * お友達押下
         * ---------------------------------------------- */
         /** ----------------------------------------------
         * ✖ボタン押下
         * ---------------------------------------------- */
        CloseEvent () {
            this.alertError = true;
            this.selectedCompanionPlayers = [];
            this.$emit('close-dialog');
        },
        /** ----------------------------------------------
         * ローディング開始
         * ---------------------------------------------- */
        loadingOn: function (){
            this.loadingCount++;
            this.$store.commit("loading/setIsLoading", true);
        },
        /** ----------------------------------------------
         * ローディング終了
         * ---------------------------------------------- */
        loadingOff: function (){
            this.loadingCount--;
            if (this.loadingCount == 0) {
                this.$store.commit("loading/setIsLoading", false);
            }
        }
    }
}

</script>

<style scoped>
</style>